import { model, Model } from 'mst-collection';
import { types } from 'mobx-state-tree';

import { useRoot } from '@models/useRoot';
import { LatestSectionsListModel } from './LatestSectionsListModel';
import { MyHubSectionsListModel } from './MyHubSectionsListModel';

export class Sections extends Model({
  latest: types.optional(LatestSectionsListModel, {}),
  myHub: types.optional(MyHubSectionsListModel, {}),
}) {}

export const SectionsModel = model(Sections);

export function useSectionsModel() {
  const root = useRoot();

  return root.sections;
}
